import {doDelete, doGet, doPost, doPut, sanitizeFilterObject} from './http.service'
import {Proposal, ProposalStatus} from "../types/Proposal";
import {Page} from "../types/Page";

export interface ProposalFilter {
    page: number,
    size: number,
    sortKey: string,
    sortOrder: 'asc'|'desc',
    phone?: string
    name?:string
    source?:string
    address?:string
    priceMin?:string
    favorite?:boolean
    priceMax?:string
    pricePerMeterMin?:string
    pricePerMeterMax?:string
    areaMin?:string
    areaMax?:string
    id?:string
    my?:boolean
    polygon?: { lat: number; lng: number }[]
    proposalStatuses: ProposalStatus[]
    /** Skip images/description on the list endpoint (dashboard analitics). */
    light?: boolean
    lat?: number
    lng?: number
    rangeKm?: number
}

export function prepareProposalFilter(filter: ProposalFilter) {
    const out = { ...filter }
    if (out.id) {
        out.id = out.id + "%";
    }
    if (out.name) {
        out.name = "%" + out.name + "%";
    }
    if (out.phone) {
        out.phone = "%" + out.phone + "%";
    }
    if (out.address) {
        out.address = "%" + out.address + "%";
    }
    if (out.polygon && out.polygon.length > 0) {
        //@ts-ignore
        out.polygon = out.polygon.map(p => {
            return p.lat + "," + p.lng
        })
    } else {
        out.polygon = undefined;
    }
    return sanitizeFilterObject(out);
}

export function loadSources() {
    return doGet<string[]>('/proposals/sources')
}
export function loadProposals(filter: ProposalFilter) {
    return doGet<Page<Proposal>>('/public/proposals', {params: prepareProposalFilter(filter)});
}
export function loadProposal(id:string) {
    return doGet<Proposal>('/public/proposals/' + id);
}
export function findEditId(id:string) {
    return doGet<Proposal>('/public/proposal-by-edit/' + id);
}
export function updateProposal(proposal: Proposal) {
    return doPut<Proposal>('/proposals/' + proposal.id, proposal);
}
export function updateProposalPublic(proposal: Proposal) {
    return doPut<Proposal>('/public/proposal-by-edit/' + proposal.editId, proposal);
}
export function createProposal(proposal: Proposal) {
    return doPost<Proposal>('/public/proposals', proposal);
}
export function updateFavorite(proposalId: string) {
    return doPut<void>('/proposals/' + proposalId + "/favorite");
}
export function deleteProposal(id: string) {
    return doDelete<void>('/proposals/' + id);
}

export function updateProposalStatus(id: string, proposalStatus:ProposalStatus) {
    return doPut<Proposal>('/proposals/' + id + '/proposal-status', {proposalStatus});
}

export function sendToTelegram(id:string) {
    return doPost<void>('/proposals/' + id + '/telegram');
}

export function sendToFacebook(id:string) {
    return doPost<void>('/proposals/' + id + '/facebook');
}


export function generatePdfReport(idList:string[]) {
    return doPost<Blob>('/proposals/pdf', idList, {
        responseType: 'blob'
    }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        // Create a temporary link to trigger download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'document.pdf'); // filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revoke the object URL after download
        window.URL.revokeObjectURL(url);
    });
}
